import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { uploadFileToS3 } from '@/helpers';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { useCreateModel } from '../api';
import { ModelForm } from '../components';
import { ModelFormValues } from '../validations';

export const NewModelPage: FC = () => {
  const navigate = useNavigate();

  const { createModelMutation, uploadUrlDataMutation } = useCreateModel();

  const saveModel = async (values: ModelFormValues) => {
    try {
      let key: string | undefined;

      if (values.archiveUrl instanceof File) {
        const { url, key: uploadKey } =
          await uploadUrlDataMutation.mutateAsync();
        await uploadFileToS3({ file: values.archiveUrl, uploadUrl: url });
        key = uploadKey;
      }

      await createModelMutation.mutateAsync({
        name: values.name,
        typeId: values.typeId,
        colorId: values.colorId,
        genderId: values.genderId,
        fileNameId: values.fileNameId,
        ...(key && { key }),
      });
      navigate(Routes.Models, { replace: true });
      toast.success(`Model “${values.name}” added successfully!`);
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <ModelForm onSubmit={saveModel}>
      <PageHeader
        title="New Model"
        asChildPage
        backPath={Routes.Models}
        actions={[
          <Button
            key="create-model"
            type="submit"
            data-testid="create-model-button"
            isLoading={
              createModelMutation.isPending || uploadUrlDataMutation.isPending
            }
            startIcon={<PlusSquareIcon />}
          >
            Create new model
          </Button>,
        ]}
      />
    </ModelForm>
  );
};
